import React from 'react';
import { DataList, createInitialFilters, CustomModal } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../useService';
import { columnConfigs, activeFilter } from './listConfig';

const ListAllCoupons: React.FC<{}> = () => {
	const { getAllCoupons } = useService();

	return (
		<>
			<CustomModal />
			<DataList
				fetchData={getAllCoupons}
				columnConfigs={columnConfigs}
				hideActions
				entity={LIST_ENTITY_NAMES.COUPONS}
				initialFilters={createInitialFilters(activeFilter)}
				initialSortDirection='ASC'
				initialSortIndex={0}
			/>
		</>
	);
};

export default ListAllCoupons;
